import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import multiguard from '@appbase/router/vue-router-multiguard.helper'
import I18nGuard from './office-i18n-guard'
import { CssGuard } from './office-css-guard'
import ErrorView from '@appbase/views/ErrorView.vue'

import Master from '@/views/Master.vue'

import moduleSentstatus from '../modules/sentstatus/router'
import moduleBigfile from '../modules/bigfile/router'
import moduleRecipient from '../modules/recipient/router'
import officeAuthGuard from './office-auth-guard'


Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'main',
        component: Master,
        beforeEnter: multiguard([
            officeAuthGuard, I18nGuard, CssGuard
        ], []),
        redirect: 'recipient',
        children: [   
            ...moduleSentstatus,
            ...moduleBigfile,
            ...moduleRecipient
        ]   
    },
    {
        path: '/error',
        name: 'error',
        component: ErrorView
    }   
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
